/**
 * @desc 根据接收时间导出邮件消息
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(params: API.crm.mailMessage.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/crm/mailMessage/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
